import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f808359c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f808359c')) {
      api.createRecord('f808359c', component.options)
    } else {
      api.reload('f808359c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f808359c&", function () {
      api.rerender('f808359c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms/users/index.vue"
export default component.exports